<template>
  <ValidationObserver
    ref="calculate-form"
    tag="div"
    class="bg-[#E9E7E6] p-8 rounded-lg">
    <div class="mb-6">
      <div class="font-normal text-2xl text-secondary mb-2">
        วงเงินที่ต้องการกู้
      </div>
      <div class="w-full">
        <CurrencyField
          v-model.number="amountLoan"
          :rules="{
            required: true
          }"
          name="วงเงินที่ต้องการกู้"
          placeholder="กรอกวงเงินที่ต้องการกู้"
          @keypress.native="$keypressNumber($event)">
          <template #append>
            <p>บาท</p>
          </template>
        </CurrencyField>
      </div>
    </div>
    <div class="mb-6">
      <div class="font-normal text-2xl text-secondary mb-2">
        ระยะเวลาที่ต้องการผ่อนชำระ <span class="font-light text-sm text-[#876D48]"> *สูงสุดไม่ควรเกิน 30 ปี </span>
      </div>
      <div class="w-full">
        <TextField
          v-model.number="years"
          :rules="{
            required: true,
            between: [1, 30]
          }"
          name="ระยะเวลาที่ต้องการผ่อนชำระ"
          placeholder="กรอกวงเงินที่ต้องการกู้"
          @keypress.native="$keypressNumber($event)">
          <template #append>
            <p>ปี</p>
          </template>
        </TextField>
      </div>
    </div>
    <div>
      <div class="mb-6">
        <div class="font-normal text-2xl text-secondary mb-2">
          อัตราดอกเบี้ย
        </div>
        <div class="flex flex-col lg:flex-row mb-5 w-full">
          <div class="flex flex-col md:flex-row">
            <div class="my-3 mr-4 md:mr-[52px] lg:mr-5">
              <span class="font-normal text-secondary mb-2">ธนาคาร</span>
            </div>
            <DropDown
              v-model="bank"
              :rules="{
                selection_required: true
              }"
              class=" w-full lg:w-[298px]"
              name="ธนาคาร"
              :items="banks"
              item-text="bankName">
              <template #item="{ item }">
                <div class="flex">
                  <div class="img">
                    <img
                      class="w-6 h-6 mr-3"
                      :src="item.image">
                  </div>
                  {{ item ? item.bankName : '' }}
                </div>
              </template>
              <template #value="{ value }">
                <div class="flex">
                  <div class="img">
                    <img
                      v-if="value && value.image"
                      class="w-6 h-6 ml-3 mr-3"
                      :src="value.image">
                  </div>
                  {{ value ? value.bankName : '' }}
                </div>
              </template>
              <template #arrow-icon="{ open }">
                <img
                  src="/svg/arrowdown.svg"
                  class="arrow-down mr-5"
                  :class="{ 'open': open }">
              </template>
            </DropDown>
          </div>
          <div class="md:flex md:grow lg:flex lg:grow lg:ml-14 xl:pl-14 xl:pr-4">
            <span
              class="font-normal text-secondary w-[15%] lg:w-[20%] md:mt-[10px] lg:mr-4
              xl:mr-[-16px] 2xl:mr-[-30px] 3xl:mr-[-180px]">อัตราดอกเบี้ย</span>
            <label class="relative md:w-[85%] lg:w-[85%]">
              <input
                :value="interest"
                disabled
                class="font-regular text-black bg-white opacity-100 rounded-md outline-none disabled
                ml-0 md:ml-0 mt-4 md:mt-0 lg:mt-0 xl:mt-0
                w-full sm:w-full md:w-full lg:w-[298px] xl:w-[298px] h-12 px-4">
              <span
                class="absolute top-[-1px] right-[12px] md:top-[10px] md:right-[18px] lg:right-[30%] xl:right-[52%] 2xl:right-[64%] 3xl:right-[83%]">
                %
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="mb-11">
        <div class="font-light text-info">
          * ที่มา : ธนาคารแห่งประเทศไทย
        </div>
        <div class="font-light text-info">
          ** ผลการประเมินจากเครื่องคำนวณสินเชื่อบ้านเป็นเพียงการประเมินวงเงินกู้ในเบื้องต้น
          ส่วนการอนุมัติสินเชื่อสงวนสิทธิ์เป็นไปตามหลักเกณฑ์ของธนาคาร
        </div>
        <div class="font-light text-info">
          *** อัตราดอกเบี้ยที่นำมาใช้คำนวณสินเชื่อบ้านของแต่ละสถาบันการเงินในที่นี้
          เป็นอัตราดอกเบี้ยชนิด MRR ของแต่ละธนาคาร โดยไม่ได้อ้างอิงส่วนลด
        </div>
        <div class="font-light text-info">
          ****รายได้รับขั้นต่ำของผู้กู้ร่วม (ถ้ามี) คำนวณโดยการประมาณรายได้จากภาระหนี้สูงสุดต่อเดือนประมาณ 40% ของรายได้
        </div>
      </div>
      <div class="mb-8">
        <button
          class="bg-[#876D48] text-center rounded-md w-full sm:w-64 h-10 p-2 pb-8 font-light text-white"
          @click="calculateCredits()">
          คำนวณเงินกู้
        </button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import banklist from '@/assets/json/banks.json'
import DropDown from '@/components/Form/DropDown.vue'
import TextField from '@/components/Form/TextField.vue'
import CurrencyField from './Form/CurrencyField.vue'

export default {
  name: 'LoanCalculate',
  components: {
    DropDown,
    TextField,
    CurrencyField
  },
  data () {
    return {
      bank: null,
      banks: banklist,
      amountLoan: null,
      years: null
    }
  },
  computed: {
    interest () {
      return this.bank?.rate || null
    }
  },
  methods: {
    async calculateCredits () {
      const vaild = await this.$refs['calculate-form'].validate()
      if (vaild) {
        const decimalInterest = ((this.interest / 100) / 12)
        const month = (this.years * 12)
        const installment = (this.amountLoan / ((1 - (1 / (1 + decimalInterest) ** month)) / decimalInterest))
        const revenue = (installment * 100) / 40
        this.$emit('calculate', { installment, revenue, amountLoan: this.amountLoan })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
img.arrow-down {
  transition: transform 250ms;
}
img.arrow-down.open {
  transform: rotate(180deg);
}
</style>
